export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14648.9267bd3c.jpg";